
<template>
  <layout-header />
  <layout-sidebar />

  <div class="page-wrapper">
    <div class="content">
      <div class="page-header">
        <div class="add-item d-flex">
          <div class="page-title">
            <h4>Podcasts</h4>
            <h6>Manage podcasts</h6>
          </div>
        </div>

        <ul class="table-top-head">
          <li>
            <a
                ref="collapseHeader"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Collapse"
                @click="toggleCollapse(collapseHeader)"
            >
              <i data-feather="chevron-up" class="feather-chevron-up"></i>
            </a>
          </li>
        </ul>

        <div class="page-btn">
          <a
              href="javascript:void(0);"
              class="btn btn-added"
              @click="addNewPodcast"
          >
            <vue-feather type="plus-circle" class="me-2" />
             Add Podcast
          </a>
        </div>
      </div>

      <!-- Search / Filters -->
      <div class="card">
        <div class="card-body pb-0">
          <div class="table-top table-top-new">
            <div class="search-set mb-0">
              <div class="search-input">
                <a href="" class="btn btn-searchset">
                  <i data-feather="search" class="feather-search"></i>
                </a>
                <input
                    type="search"
                    class="form-control"
                    v-model="searchPodcast"
                    @input="loadPodcast"
                    placeholder="Search podcasts..."
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Podcast Cards -->
      <div class="employee-grid-widget row">
        <PodcastCard
            v-for="podcast in podcastStore.podcasts"
            :key="podcast.id"
            :podcast="podcast"
        />
      </div>

      <!-- Pagination -->
      <div class="d-flex justify-content-center mt-4" v-if="podcastStore.pagination.total > podcastStore.pagination.per_page">
        <a-pagination
            :current="podcastStore.pagination.current_page"
            :page-size="podcastStore.pagination.per_page"
            :total="podcastStore.pagination.total"
            show-size-changer="false"
            @change="loadPodcast"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import { toggleCollapse } from "@/utils/components";
import { usePodcastStore } from "@/store/podcastStore";
import { useRouter } from "vue-router";
import PodcastCard from "@/views/pages/podcast/components/podcast-card.vue";

const router = useRouter();
const podcastStore = usePodcastStore();

const collapseHeader = ref(null);
const searchPodcast = ref("");

function addNewPodcast() {
  router.push({ name: "add-edit-podcast", params: { action: "add" } });
}

// async function loadPodcast() {
//   await podcastStore.fetchPodcasts({ search: searchPodcast.value });
// }

async function loadPodcast(page = 1) {
  await podcastStore.fetchPodcasts({
    search: searchPodcast.value,
    page,
  });
}

watch(searchPodcast, () => {
  loadPodcast(1);
});

onMounted(loadPodcast);
</script>

